import { render, staticRenderFns } from "./dashBusinessIndex.vue?vue&type=template&id=110ba2ac&scoped=true&"
import script from "./dashBusinessIndex.vue?vue&type=script&lang=js&"
export * from "./dashBusinessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ba2ac",
  null
  
)

export default component.exports